import Box from 'carbon-react/esm/components/box';
import { LayoutProps } from './types/layout.types';
import { PublicErrorBoundary } from './ErrorBoundary/PublicErrorBoundary';

export const PublicLayout = ({ children, withErrorBoundary }: LayoutProps) => {
  const content = withErrorBoundary ? (
    <PublicErrorBoundary errorLayout="PublicLayout">{children}</PublicErrorBoundary>
  ) : (
    children
  );

  return (
    <Box
      height="700px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      {content}
    </Box>
  );
};
